import React from "react"
import { makeStyles } from "@material-ui/styles"
import { Chip } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  root: {
    fontWeight: "600",
    color: "white",
    backgroundColor: theme.palette.invited.main,
  },
}))

const InvitedChip = ({ className, label = "Invited" }) => {
  const classes = useStyles()

  return <Chip label={label} classes={classes} className={className} size="small" />
}

export { InvitedChip }
